import RelatedDetail from '../../../related/_detail';

// Related site detail (EN). Copy and images: src/data/related/butler-bell.ts; FAQ: src/data/faq.json (/en/related/butler-bell).
export default function EnRelatedButlerBellPage() {
  return <RelatedDetail slug="butler-bell" lang="en" />;
}
